import { Store } from 'react-admin';

// Used by react-admin's Configurable components (DatagridConfigurable, SimpleListConfigurable...)
const PREFERENCES_PREFIX = 'preferences.';
// Default keys of react-admin's DataTable: `${resource}.datatable` holds the hidden columns
// and `${resource}.datatable_columnRanks` holds the column order
const DATATABLE_SUFFIXES = ['.datatable', '.datatable_columnRanks'];

const isPreference = (key: string): boolean => key.startsWith(PREFERENCES_PREFIX)
  || DATATABLE_SUFFIXES.some((suffix) => key.endsWith(suffix));

const preferenceKeepingStore = (store: Store): Store => ({
  ...store,
  reset: (): void => {
    Object.keys(store.listItems?.() ?? {})
      .filter((key) => !isPreference(key))
      .forEach((key) => store.removeItem(key));
  },
});

export default preferenceKeepingStore;
